export default "__VITE_ASSET__8f192444__"